import type { SessionState } from "../../platform/net/session";

/** Player-facing text for a session state; empty when there is nothing to say. */
export function connectionText(state: SessionState): string {
  switch (state.kind) {
    case "connecting":
      return "Connecting…";
    case "reconnecting":
      return "Reconnecting…";
    case "ready":
    case "paused":
      return "";
    case "maintenance":
      return state.until === undefined
        ? "The game is under maintenance. We'll be back soon."
        : `The game is under maintenance until ${new Date(state.until).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}.`;
    case "fatal":
      switch (state.reason.kind) {
        case "replaced":
          return "You're playing on another device.";
        case "outdated":
          return "A new version is available. Please update the game to keep playing.";
        case "closed":
          return "Can't connect to the game server.";
      }
  }
}
